import { useDisclosure } from "@mantine/hooks";
import {
  Modal,
  Container,
  Title,
  Image,
  Center,
  Button,
  Text,
  Flex,
  createStyles,
  rem,
} from "@mantine/core";
import { Link } from "react-router-dom";
import homePageModalImage from "../images/home_page_modal.webp";
import mascotCelebrate from "../images/brand/mascot-celebrate.webp";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { homePrimaryButton } from "./homeButtonStyles";

const companyLogo = `${process.env.PUBLIC_URL || ""}/companylogo2.png`;

const useStyles = createStyles((theme) => ({
  logo: {
    height: 56,
    width: "auto",
    objectFit: "contain",
    display: "block",
    marginBottom: theme.spacing.sm,
  },
  title: {
    fontFamily: theme.headings?.fontFamily || '"Noto Serif TC", serif',
    color: theme.colors.gray[8],
    fontSize: "clamp(1.2rem, 2vw, 1.5rem)",
    fontWeight: 600,
    letterSpacing: "0.04em",
  },
  subtitle: {
    color: theme.colors.gray[7],
    fontSize: theme.fontSizes.md,
    marginTop: theme.spacing.sm,
    lineHeight: 1.6,
  },
  ctaText: {
    color: theme.colors.orange[7],
    fontSize: theme.fontSizes.md,
    fontWeight: 600,
    marginTop: theme.spacing.md,
  },
  promoHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.md,
    marginTop: theme.spacing.sm,
    marginBottom: theme.spacing.xs,
  },
  mascotModal: {
    height: rem(80),
    width: "auto",
    objectFit: "contain",
    flexShrink: 0,
  },
  ctaBtn: homePrimaryButton(theme),
}));

const HomePageHoverContent = () => {
  const [opened, { close }] = useDisclosure(true);
  const { classes } = useStyles();

  return (
    <Modal opened={opened} size="xl" onClose={close} radius="lg" title={null}>
      <Container>
        <Center>
          <img src={companyLogo} alt="猫山王朝" className={classes.logo} />
        </Center>
        <div className={classes.promoHeader}>
          <img
            src={mascotCelebrate}
            alt=""
            className={classes.mascotModal}
            width={80}
            height={80}
            aria-hidden
          />
          <Title order={2} className={classes.title}>
            批發 - 試板預約
          </Title>
        </div>
        <Text className={classes.subtitle}>
          產品包括急凍榴槤果肉、急凍榴槤果泥等等。歡迎查詢
        </Text>
        <Text className={classes.ctaText}>
          隨時 WhatsApp 聯絡 9831 2915，預約批發報價，直送試板!!
        </Text>
        <Flex my="xl">
          <Button className={classes.ctaBtn} component={Link} to="/contact" radius="xl" size="md" leftIcon={<IconBrandWhatsapp size={20} />}>
            +852 98312915
          </Button>
        </Flex>
        <Center>
          <Image src={homePageModalImage} alt="貓山王朝批發試板預約 - 馬來西亞榴槤急凍果肉果泥產品" radius="md" loading="eager" />
        </Center>
      </Container>
    </Modal>
  );
};

export default HomePageHoverContent;
